module.exports = __webpack_public_path__ + "d4dab444eebc9c1623afb5cde1d9ff72.MP3";